import React, { FC, useCallback, useEffect, useState } from 'react';

import { ReactTable } from '@nhl/nhl-breakaway-ui';
import { ColumnDef } from '@tanstack/react-table';

import { Goalie, GoalieSeasonStat, Skater, SkaterSeasonStat } from '../../types';

import { LeftShadow, TeamRosterTableContainer } from './styles';

type Props = {
    initialSort: { id: string; desc: boolean }[];
    data: Array<SkaterSeasonStat | Skater | GoalieSeasonStat | Goalie>;
    columns: Array<ColumnDef<SkaterSeasonStat | Skater | GoalieSeasonStat | Goalie>>;
};

export const LeftShadowTable: FC<Props> = ({ initialSort, data, columns }) => {
    const [tableChild, setTableChild] = useState<HTMLDivElement>();
    const [tableScroll, setTableScroll] = useState<number>(0);

    const onTableMounted = useCallback((node: HTMLDivElement) => {
        if (node) {
            setTableChild(node.getElementsByClassName('rt-table-container')[0] as HTMLDivElement);
        }
    }, []);

    useEffect(() => {
        const updateTableScroll = () => {
            tableChild && setTableScroll(Math.min(tableChild.scrollLeft, 32));
        };

        tableChild?.addEventListener('scroll', updateTableScroll);

        return () => {
            tableChild?.removeEventListener('scroll', updateTableScroll);
        };
    }, [tableChild]);

    const rect = tableChild?.getBoundingClientRect();
    const height = rect?.height || 0;
    const top = tableChild?.offsetTop || 0;

    return (
        <TeamRosterTableContainer ref={onTableMounted}>
            <ReactTable columns={columns} data={data} initialSorting={initialSort} />
            <LeftShadow $scrollPosition={tableScroll} $shadowHeight={height} $toTop={top} />
        </TeamRosterTableContainer>
    );
};
